// extracted by mini-css-extract-plugin
export var arrow = "_42-6";
export var changeItem = "_42-3";
export var changesHeader = "_42-1";
export var changesList = "_42-2";
export var container = "_42-0";
export var pathLabel = "_42-4";
export var value = "_42-7";
export var valuesContainer = "_42-5";